import { ModalService } from './../../modal/modal.service'
import { Component } from '@angular/core'
import { MatDialogConfig } from '@angular/material/dialog'
import { ArquivosSistemaService } from '@app/modules/configuracoes/arquivos/arquivos.service'
import { ArquivoModel } from '@shared/models/backend'
import { environment } from 'src/environments/environment'

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  projectVersion = environment.version

  constructor(private modalService: ModalService, private arquivosSistemaService: ArquivosSistemaService) {}

  onClick(): void {
    this.arquivosSistemaService.getArquivosModeloInstitucional().subscribe({
      next: (arquivos: ArquivoModel[]) => {
        const dialogConfig = new MatDialogConfig()

        dialogConfig.width = '60em'
        dialogConfig.data = {
          title: 'Modelos de arquivos institucionais',
          files: arquivos,
        }

        this.modalService.openFileListModal(dialogConfig)
      },
    })
  }
}
